<template>
<div>

    <div class="fxboex head">
        <div class="title">会员登录</div>
    </div>
<!--    <div class="tabpanel_lh"></div>-->

    <div class="account">
<!--        <div class="actnav">-->
<!--            <span>登录</span>-->
<!--            <router-link to="/register">注册</router-link>-->
<!--        </div>-->
        <div class="login">
            <h1>会员登录</h1>
            <form data-action="{% url 'login-vaild' %}" id="loginform" method="post">
                <div class="item">
                    <i class="user"></i>
                    <input class="put" type="text" ref="name" v-model="account" placeholder="账号" autocomplete="off"/></div>
                <div class="item">
                    <i class="pwd"></i>
                    <input class="put" type="password" ref="pwd" v-model="password" placeholder="密码" autocomplete="off"/></div>
                <div class="item">
                    <i class="yzm"></i>
                    <input type="number" class="put" maxlength="5" ref="code" v-model="code" placeholder="验证码" autocomplete="off"/>
                    <yzcode @getIdentifyCode="valcode" :changeCode="changeCode" class="code"/>
                </div>
<!--                <div class="item itempd">-->
<!--                    <label><input class="chk" type="checkbox" id="chkremember">记住密码</label>-->
<!--                </div>-->
                <button type="button" @click="tologin">立即登录</button>
                <div class="rout">
                    还没有账号？<router-link to="/register" class="rg">立即注册</router-link>
                </div>
            </form>
        </div>
    </div>

</div>
</template>

<script>
    import yzcode from '../components/public/yzcode'
    export default {
        name: "login",
        components: {
            yzcode
        },
        data() {
            return {
                account: '',
                password: '',
                code: '',
                yzm: '',
                changeCode: 0
            }
        },
        // watch: {
        //     '$route'(){
        //         console.log(this.$store.state.isLogin)
        //     }
        // },
        activated() {

        },
        methods: {
            valcode(data){
                this.yzm = data
            },
            tologin () {
                let that = this
                if(that.account === ''){
                    this.$toast('请输入账号')
                    this.$nextTick(() =>{
                        this.$refs.name.focus()
                    })
                    return
                }
                if(that.password === ''){
                    this.$toast('请输入密码')
                    this.$nextTick(() =>{
                        this.$refs.pwd.focus()
                    })
                    return
                }
                if(that.code === ''){
                    this.$toast('请输入验证码')
                    this.$nextTick(() =>{
                        this.$refs.code.focus()
                    })
                    return
                }
                if(that.code !== that.yzm){
                    that.$toast('验证码不正确')
                    that.code = ''
                    that.changeCode = Math.random()
                    that.$nextTick(() =>{
                        that.$refs.code.focus()
                    })
                    return
                }
                that.$post(that.$api.login, {name: that.account, pwd: btoa(that.password)}).then(function (res) {
                    //console.log(res)
                    if(res.code === 1) {
                        that.$store.commit('LOGIN', res.data.token)
                        that.$store.commit('SET_USER', res.data.user)
                        that.changeCode = Math.random()
                        that.account = ''
                        that.password = ''
                        that.code = ''
                        that.$toast.success({
                            message: res.msg
                        })
                        setTimeout(function () {
                            that.$router.replace({path: '/ball'})
                        }, 50)
                    }
                    else{
                        that.$toast.fail(res.msg)
                        that.changeCode = Math.random()
                        that.code = ''
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
